export const formatDate = (datestring: string): string => {
  if(!datestring) return '';
        // Extract year, month, and day from the YYYYMMDD format
        const year = parseInt(datestring.substring(0, 4));
        const month = parseInt(datestring.substring(4, 6)); // Month is 0-based in JS Date, so no need to adjust
        const day = parseInt(datestring.substring(6, 8));
    
        // Create a Date object using the parsed year, month, and day
        const date = new Date(year, month-1, day);
    
        // Format the date to "weekday DD.MM.YY"
        const formattedDate = new Intl.DateTimeFormat('de-DE', {
          weekday: 'long',   // Full name of the weekday
          day: '2-digit',    // Day as two digits
          month: '2-digit',  // Month as two digits
          year: '2-digit',   // Year as two digits
        }).format(date);

        return formattedDate;
}